$( window ).load(function() {
  // Collection Filter Toogle
//$("div.filter-holder").addClass("show");
$("ul.occassion-filter-item li.coll-filters").each(function(){
if($(this).find("input[type='radio']").is(":checked")){
$("div.filter-holder").addClass("show");
}
});

$("#showFilter").on("click", function(){
$("div.filter-holder").toggleClass("show");
});
  
//shipto header click event
$(".shipto-nav").on("click", function(e){
  e.stopPropagation();
  if($(this).hasClass("active")){
    $(this).removeClass("active");
    $("body").removeClass("overlay");
  	$(".shipto-overlay").remove();
  } else {
    $(this).addClass("active");
    $("body").addClass("overlay");
  	$("body").append("<div class='shipto-overlay'></div>");
  }
	
});
$("body").on("click", function(){
    $(".shipto-nav").removeClass("active");
    $("body").removeClass("overlay");
  	$(".shipto-overlay").remove();
});

//viewport
function isScrolledIntoView(elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();

  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height();

  return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$(window).scroll(function () {
  var boxWrapper = $('.product-template__container .check-on-scroll');
  var box = $('.product-template__container .product-form__cart-submit');
    if (isScrolledIntoView(boxWrapper) === true) {
        $(box).removeClass('sticky');
    } 
    else {
      $(box).addClass('sticky');
    }  
});

var box = $('.product-template__container .product-form__cart-submit');
$(box).addClass('sticky');

// Collection Filter
//var firstFilter = $("div.filter-holder ul.filter-menu li:first-child span").data('filter');
if($('li.occassion').length){
  var firstFilter = $("div.filter-holder ul.filter-menu").find("li:gt(0) span:visible").data('filter');
  if (!firstFilter) {
   var firstFilter = $("div.filter-holder ul.filter-menu").find("li:visible:first span").data('filter');
  }
}
else {
  var firstFilter = $("div.filter-holder ul.filter-menu").find("li:visible:first span").data('filter');
}
$("div.filter-holder ul.occassion-filter-item > li." + firstFilter).addClass("show");
$("div.filter-holder ul.filter-menu li").find('span[data-filter="' + firstFilter + '"]').addClass("active");
$("div.filter-holder ul.filter-menu li span").on("click", function(){
$("div.filter-holder ul.filter-menu li span").removeClass('active');
$(this).addClass('active');
var thisDataFilter = $(this).data('filter');
$("div.filter-holder ul.occassion-filter-item > li").removeClass("show");
$("div.filter-holder ul.occassion-filter-item > li." + thisDataFilter).addClass("show");
});
});
$(document).ready(function() {
productAccordion();
tabContent();
//homepage sticky
// $(window).scroll(function() {
// var scroll = $(window).scrollTop();

// if (scroll >= 50) {
// if ((jQuery('body').attr("ju_orig_marg"))) {
// // jQuery('body').addClass('justno-bar');
// //$("body").removeClass('justno-bar-hidden');
// }
// else {
// // jQuery('body').addClass('justno-bar-hidden');
// // $("body").removeClass('justno-bar');
// }
// $(".site-header").addClass("sticky-header");
// //$("#AccessibleNav").slideUp(300);
// }
// else {
// //$("body").removeClass('justno-bar-hidden');
// //$("body").removeClass('justno-bar');
// $(".site-header").removeClass("sticky-header");
// //$("#AccessibleNav").slideDown(100);
// }
// });
//phone and ship slide functions
$("a.header-phone").click(function(){
$("div.delivery-slide").removeClass("slideFromRight");
$("a.header-ship").removeClass("active");
if($(this).hasClass('active')){
$(this).removeClass('active');
$("div.phone-slide").removeClass("slideFromRight");
}
else{
$(this).addClass("active");
$("div.phone-slide").addClass("slideFromRight");
$(".phone-slide-out").addClass('active');
}
});

$("a.header-ship").click(function(){
$("div.phone-slide").removeClass("slideFromRight");
$("a.header-phone").removeClass("active");
if($(this).hasClass('active')){
$(this).removeClass('active');
$("div.delivery-slide").removeClass("slideFromRight");
}
else{
$(this).addClass("active");
$("div.delivery-slide").addClass("slideFromRight");
$(".delivery-note-slideout").addClass('active');
}
});



$(window).scroll(function() {
if($(window).scrollTop() > 80) {
$("div.phone-slide").removeClass("slideFromRight");
$("a.header-phone").removeClass("active");
$("div.delivery-slide").removeClass("slideFromRight");
$("a.header-ship").removeClass("active");
}
});


$(".search-button").click(function(){
$('.image_fix_top').removeAttr("style");

//   $(".search-slide").slideToggle('slow');
$("body").toggleClass("search-open");

$(".header-bar__search-input").focus();

if($(this).hasClass("is-active")){
$(this).removeClass('is-active');

$(".header-bar__search-form").addClass('is-collapse');
setTimeout(function(){
$("div.search-slide").slideUp();
}, 300);

}
else{
$(this).addClass('is-active');
$("div.search-slide").slideDown();
setTimeout(function(){
$(".header-bar__search-form").removeClass('is-collapse');

},300);


}
});

//   $("button.js-mobile-nav-toggle").on("click", function(){
//     if($(this).hasClass("is-open")){
//       $(this).removeClass("is-open");
//       $("nav.mobile-nav-holder").removeClass("slide-menu");
//       $("div.page-wrapper").removeClass("slide-page");
//     }
//     else{
//       $(this).addClass("is-open");
//       $("nav.mobile-nav-holder").addClass("slide-menu");
//       $("div.page-wrapper").addClass("slide-page");
//     }
//   });


//slick js homepage-banner
$('.slider_wrap').slick({
dots: true,
infinite: true,
speed: 300,
slidesToShow: 1,
});
  
//Announcement Slides
$('.announcement-bar div.carousel').slick({
dots: false,
arrows: false,
infinite: true,
speed: 400,
fade:true,
autoplay:true,
autoplaySpeed: 4000,
pauseOnHover: true,
cssEase: 'linear',
adaptiveHeight: false,
slidesToShow: 1,
});

$('.recommended-product-holder .carousel').slick({
dots: false,
arrows: true,
infinite: true,
slidesToShow: 4,
centerMode: false,
variableWidth:false,
slidesToScroll: 1,
responsive: [
{
breakpoint: 1024,
settings: { slidesToShow: 3, slidesToScroll: 1, arrows:true }
},
{
breakpoint: 768,
settings: { slidesToShow: 2, slidesToScroll: 1, arrows:true, centerMode: false }
}
]
});

$('.related-products .carousel').slick({
centerMode: false,
  centerPadding: '60px',
  slidesToShow: 4,
  responsive: [
    {
    breakpoint: 1024,
    settings: { 
      slidesToShow: 3, 
      slidesToScroll: 1, 
      arrows:true }
    },
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 2
      }
    }
  ]
});
var winWidth = $(window).width();
//slick js featured-in
if(winWidth <= 768){
$('#featuredInSlide').slick({
dots: false,
infinite: false,
arrows:true,
speed: 300,
slidesToShow: 2,
slidesToScroll:1,
centerMode: false,
variableWidth: true
});
  $('#homepage-how-we-deliver div.carousel').slick({
dots: true,
infinite: false,
arrows:false,
speed: 300,
slidesToShow: 1,
slidesToScroll:1,
centerMode: false,
autoplay: true,
variableWidth: false,
autoplaySpeed: 3000,
adaptiveHeight: false
});
}

//slick js product detail page

$('.slider-for').slick({
slidesToShow: 1,
slidesToScroll: 1,
arrows: true,
fade: false,
adaptiveHeight: false,
infinite: false,
responsive: [
{
breakpoint: 600,
settings: { slidesToShow: 1, slidesToScroll: 1, arrows:true, dots:true }
}
]
});
$('.slider-nav').not('.slick-initialized').slick({
slidesToShow: 4,
slidesToScroll: 1,
asNavFor: '.slider-for',
dots: false,
centerMode: false,
focusOnSelect: true,
arrows: false,
variableWidth: false,
infinite: true
});

//collection-carousel
jQuery('.products-carousel').each(function(index) {
var carouselLength = $(this).find(".grid__item").length;
if(!jQuery(this).find('.slick-initialized').length){
var id = jQuery(this).attr('data-container');
  var winWidth = $(window).width();
  if(winWidth > 768){
  	if(carouselLength > 3){
    jQuery('.integrateFlexslider_'+id).slick({
    dots: false,
    arrows: true,
    adaptiveHeight: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    initialSlide: 1,
    responsive: [
    {
    breakpoint: 1024,
    settings: { slidesToShow: 3, slidesToScroll: 1, arrows:true }
    },
    {
    breakpoint: 768,
    settings: { slidesToShow: 2, slidesToScroll: 2, arrows:true, centerMode: false }
    },
    ]
    });
      }
  }
    else if(carouselLength > 1) {
      jQuery('.integrateFlexslider_'+id).slick({
        dots: false,
        arrows: true,
        adaptiveHeight: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: { slidesToShow: 3, slidesToScroll: 1, arrows:true }
          },
          {
            breakpoint: 768,
            settings: { slidesToShow: 2, slidesToScroll: 2, arrows:true, centerMode: false }
          }
        ]
      });
    }

jQuery(window).trigger('resize');
}
  
  carouselAvgHeight = $(this).find(".slick-list").innerHeight();
  $(this).find(".slick-list .grid__item").css('height', carouselAvgHeight);  

 
  
});


$("[name='updates[]']").change(function() {
$( "[name='update']" ).trigger( "click" );
});

});
  
  // Just UNO Click Trigger
$("#btn-offerMob").on('click', function(){
  	//alert();
  });

$(document).click(function(e) {
var $target = $(e.target);
if(!$target.closest('.header-phone').length && !$target.hasClass('header-phone') &&
!$target.closest('.phone-slide-out').length && !$target.hasClass('phone-slide-out')) {
$("div.phone-slide").removeClass("slideFromRight");
$("a.header-phone").removeClass("active");
}
});

$(document).click(function(e) {
var $target = $(e.target);
if(!$target.closest('.header-ship').length && !$target.hasClass('header-ship') &&
!$target.closest('.delivery-note-slideout').length && !$target.hasClass('delivery-note-slideout')) {
$("div.delivery-slide").removeClass("slideFromRight");
$("a.header-ship").removeClass("active");
}
});

function productAccordion(){
$("div.product-accordian ul li h2.acc-header").on("click", function(){
if($(this).hasClass('open')){
$(this).removeClass('open');
$(this).next('div.acc-content').slideUp();
}else{
$("div.product-accordian ul li h2.acc-header").removeClass('open');
$("div.product-accordian ul li h2.acc-header").next('div.acc-content').slideUp();
$(this).addClass('open');
$(this).next('div.acc-content').slideDown();
}
});
}
function tabContent(){
$("div.tab-menu-holder ul.tab-menu li:first-child a").addClass("current");
$("ul.tab-menu li a").on("click", function(e){
e.preventDefault();
$("ul.tab-menu li a").removeClass("current");
$(this).addClass("current");
var tabDataID = $(this).attr("tab-data");
//console.log(tabDataID);
$("div.tab-item").css("display", "none");
$("#" + tabDataID).fadeIn();
});
}
  
  setTimeout(function(){
    // To adjust the header top padding ------
    //var siteHeaderHeight = $("header.site-header").innerHeight();
    var siteHeaderHeight = $(".header_main").innerHeight();
    $("body > .page-container").css("padding-top", siteHeaderHeight);
    $(window).resize(function(){
      //var siteHeaderHeight = $("header.site-header").innerHeight();
      var siteHeaderHeight = $(".header_main").innerHeight();
      $("body > .page-container").css("padding-top", siteHeaderHeight);
    });
  },500);